import {LinkTarget} from '../shared/pipes/link-target/link-target.enum';
import {LinkOptimizationMode} from '../shared/enums/link-optimization-mode.enum';

export const SETTINGS_STORAGE_KEY = 'app-settings';
export interface LocalStorageSettings {
  webgl?: boolean;
  textureRenderer?: boolean;
  isSidebarOpen?: boolean;
  isEditMode?: boolean;
  defaultImageOpacity?: number;
  sidebarWidth?: number;
  forceOpened?: boolean;
  linkTarget?: LinkTarget;
  aiGenerationLongPressOnly?: boolean;
  gridIntensity?: number;
  defaultAppearance?: string;
  linkOptimizationMode?: LinkOptimizationMode;
  livePreviewsEnabled?: boolean;
  snapshotPreviewsEnabled?: boolean;
  tooltipsEnabled?: boolean;
  tooltipFadingEnabled?: boolean;
  optimizeLinkSelection?: boolean;
  /**
   * MAP-1688: whether a name, description or property edit made while several
   * elements are selected reaches all of them. Off by default, so the work put
   * into the others is not overwritten by accident.
   */
  applyEditsToMultiselection?: boolean;
  openInfoPanelOnFocus?: boolean;
  imageGenerationWarningDismissed?: boolean;
}
